import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import styled from 'styled-components';
import { Typography, Button as MuiButton, Grid } from '@material-ui/core';
import Img from 'gatsby-image/withIEPolyfill';
import PortableText from '@sanity/block-content-to-react';

const OuterContainer = styled.section`
  position: relative;
  left: -2.5%;
  height: 83vh;
  width: 105%;

  border-bottom-left-radius: 52.5% 4.5rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background: ${props => props.theme.palette.primary.main};
`;

const InnerContainer = styled(BackgroundImage)`
  left: -2.5%;
  width: 105%;
  height: 80vh;
  border-bottom-left-radius: 52.5% 5.5rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background-position: 50% 40%;

  &::before,
  &::after {
    left: -2.5%;
    width: 105%;
    height: 80vh;
    background-position: 50% 40%;
    border-bottom-left-radius: 52.5% 5.5rem;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
`;

const Heading = styled(Typography)`
  width: 100%;
  margin-top: 1rem;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  color: white;
  position: absolute;
  font-weight: 500;
  top: 40%;
  left: 0;
`;

const SiteMessage = styled(Typography)`
  width: 90%;
  padding: 0 1rem;
  text-align: center;
  margin-bottom: -1rem;
`;

const Logo = styled(Img)`
  margin: 0 auto;
  width: 325px;
`;

const Button = styled(MuiButton)`
  position: absolute;
  bottom: 10%;
  width: 200px;
  left: calc(50% - 100px);
`;

const Hero = ({
  heroImage,
  heroMessage,
  heroLogo,
  heroHeading,
  heroButton,
}) => (
  <OuterContainer>
    <InnerContainer
      fluid={heroImage.asset.fluid}
      alt={`${heroHeading == null ? '' : heroHeading} Page Image`}
    >
      {/* <SiteMessage component={<PortableText blocks={heroMessage} />} /> */}

      {heroLogo ? <Logo fluid={heroLogo.asset.fluid} /> : ''}

      {heroHeading == null ? '' : <Heading variant="h1">{heroHeading}</Heading>}

      {heroButton ? (
        <Button
          variant="contained"
          size="large"
          color="secondary"
          type="button"
          component="a"
          href="#request"
          name="Request Service"
        >
          Request Service
        </Button>
      ) : (
        ''
      )}
    </InnerContainer>
  </OuterContainer>
);

export default Hero;
